import React from 'react';
import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import { graphql } from 'react-apollo';
import LoadingIndicator from 'components/LoadingIndicator';
import SafeMarkdown from 'components/SafeMarkdown';
import { errorShape } from 'utils/shapes';

function PrivacyPolicyContent({
  data: { privacyPolicyAsMarkdown, loading, error }
}) {
  let content;
  if (loading) {
    content = <LoadingIndicator />;
  } else if (error || !privacyPolicyAsMarkdown) {
    content =
      'An error occured while fetching the privacy policy. Please try again.';
  } else {
    content = (
      <SafeMarkdown
        source={privacyPolicyAsMarkdown.privacyPolicy}
        role="article"
      />
    );
  }

  return <div className="privacy-policy-content">{content}</div>;
}

PrivacyPolicyContent.propTypes = {
  data: PropTypes.shape({
    privacyPolicyAsMarkdown: PropTypes.shape({
      privacyPolicy: PropTypes.string
    }),
    loading: PropTypes.bool,
    error: errorShape
  })
};

const QUERY_GET_TERMS = gql`
  query MyGetPrivacyPolicy {
    privacyPolicyAsMarkdown {
      privacyPolicy
    }
  }
`;

const withData = graphql(QUERY_GET_TERMS);

export default withData(PrivacyPolicyContent);
